import 'react-app-polyfill/ie9'
import "core-js"
import React from 'react'
import ReactDOM from 'react-dom'

import StopAccess from './main/components/stopAccess'
// import Router from './main/components/router/index'
// import util from './main/util/tools'

import 'antd-mobile/dist/antd-mobile.css'
import './common/util/rootFont'
import './common/style/App.css'
import './common/style/icon.css'
import './common/style/flex.css'
import './main/components/free/index.css'
import './main/components/bookDetail/index.css'
import 'react-photo-view/dist/react-photo-view.css'

// util.loadFirst(renderDom, App)

function renderDom(){
    // return ReactDOM.render(<Router />, document.querySelector('#root'))
    return ReactDOM.render(<StopAccess />, document.querySelector('#root'))
}

renderDom()

// function App() {
//     return (
//         <Router/>
//     )
// }
